import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Gallery.css';
import { useSEO } from '../hooks/useSEO';
import { getImageUrl } from '../utils/imageUrl';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Gallery = () => {
  useSEO('/gallery');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    try {
      const response = await axios.get(`${API}/gallery`);
      setGalleryImages(response.data.images || []);
    } catch (error) {
      console.error('Error fetching gallery:', error);
    } finally {
      setLoading(false);
    }
  };

  // Get unique categories from images
  const categories = [
    { id: 'all', label: 'All Images' },
    ...Array.from(new Set(galleryImages.map(img => img.category)))
      .map(cat => ({
        id: cat,
        label: cat.charAt(0).toUpperCase() + cat.slice(1)
      }))
  ];

  if (loading) {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading gallery...</div>;
  }

  const filteredImages = selectedCategory === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === selectedCategory);

  return (
    <div className="gallery">
      {/* Hero Section */}
      <section className="gallery-hero">
        <div className="container">
          <h1 className="hero-medium">Gallery</h1>
          <p className="body-large gallery-subtitle">
            Glimpse into the magical moments we've created on Jamaica's stunning beaches
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="gallery-filters section-padding-small">
        <div className="container">
          <div className="filter-buttons">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`filter-button ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="gallery-grid-section">
        <div className="container">
          <div className="gallery-grid">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="gallery-item hover-lift"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={getImageUrl(image.url)}
                  alt={image.alt}
                  className="gallery-image"
                />
                <div className="gallery-overlay">
                  <span className="body-small">View</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="lightbox-close"
              onClick={() => setSelectedImage(null)}
              aria-label="Close"
            >
              ×
            </button>
            <img
              src={getImageUrl(selectedImage.url)}
              alt={selectedImage.alt}
              className="lightbox-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;